import { render } from "./CategoryManagementView.vue?vue&type=template&id=8188853e&scoped=true&ts=true"
import script from "./CategoryManagementView.vue?vue&type=script&lang=ts"
export * from "./CategoryManagementView.vue?vue&type=script&lang=ts"

import "./CategoryManagementView.vue?vue&type=style&index=0&id=8188853e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8188853e"]])

export default __exports__